import About from "../../../sections/about/About";
import "../dashboard.css"

const AboutDashboard = () => {
  return (
    <div>
      <div className="container kurumsal-container">
        <div className="bread-list">
          <hr />
          <ul>
            <li className="return-mainpage">
              <a href="../#header">ANASAYFA</a>
            </li>

            <li>|</li>

            <li>Hakkımızda</li>
          </ul>
          <hr />
        </div>
      </div>
      <About />
    </div>
  );
};

export default AboutDashboard;
